import {
  CONFIRMATION_FILE_TYPE,
  ORDER_STATUS_TYPE,
} from '@/api/type/commonTypes';
import { Images } from '@/assets';
import { fonts } from '@/theme/fonts';
import { formatFileSize } from '@/utils/file/formatFileSize';
import styled from 'styled-components';

interface OrderFileListProps {
  fileList: CONFIRMATION_FILE_TYPE[];
  uploadedBy: 'PARTNER' | 'PLAYER';
  onClickIcon: (fileId: string, fileName?: string) => () => void;
  status: ORDER_STATUS_TYPE;
}

const OrderFileList = ({
  fileList,
  uploadedBy,
  onClickIcon,
  status,
}: OrderFileListProps) => {
  const fileDeleteEnable = status === 'IN_PROGRESS';
  return (
    <ListBox>
      {fileList.length > 0 &&
        fileList.map((item) => (
          <UploadItem key={item.id}>
            <FileName>{item.name}</FileName>
            <DeleteWrap>
              <FileName>{formatFileSize(item.size)}</FileName>
              {uploadedBy === 'PLAYER' && (
                <DownloadButton onClick={onClickIcon(item.id, item.name)} />
              )}
              {uploadedBy !== 'PLAYER' && fileDeleteEnable && (
                <DeleteButton onClick={onClickIcon(item.id, item.name)} />
              )}
            </DeleteWrap>
          </UploadItem>
        ))}
    </ListBox>
  );
};

export default OrderFileList;

const ListBox = styled.div`
  margin: 1px;
  box-shadow: 0px 0px 4px rgba(91, 75, 232, 0.25);
  background: #fff;
  border-radius: 10px;
  padding: 9px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;
  overflow-y: auto;
  height: 100%;
  width: 300px;
  height: 367px;
  box-sizing: border-box;
`;

const UploadItem = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 6px 15px;
  width: 100%;
  box-sizing: border-box;
`;

const FileName = styled.div`
  font-family: ${fonts.family.poppins};
  font-size: 16px;
  line-height: 120%;
  color: #000000;
  text-align: start;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  min-width: 0;
`;

const DeleteWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const DownloadButton = styled.button`
  background-image: url(${Images.DownloadButtonImg});
  width: 26px;
  height: 18px;
  background-position: center;
  background-size: contain;
`;

const DeleteButton = styled.button`
  background-image: url(${Images.DeleteButtonImg});
  width: 20px;
  height: 20px;
  background-position: center;
  background-size: contain;
`;
